import React, { Fragment } from "react"
import { useSelector } from "react-redux"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import { productUnitsSymbol } from "constant"
import classes from "./CheckoutOrderItem.module.scss"

const CheckoutOrderItem = props => {
  const {
    orderItem,
    doesOrderHasOneItem,
    selectedOrderItems,
    setSelectedOrderItems,
    orderHasCoupons
  } = props

  const [t, i18n] = useTranslation()

  const orderForEditDetails =
    useSelector(state => state.orderForEditDetails)

  const isOnline =
    useSelector(state => !state.internetStatus.forceOffline) &&
    !orderForEditDetails?.offlineOrderId

  const handleSelect = () => {
    if (!isSelectable) return

    setSelectedOrderItems(prev =>
      isSelected
        ?
        prev.filter(oi =>
          oi.orderItemId !== orderItem.orderItemId &&
          oi.mainFoodOrderItemId !== orderItem.orderItemId
        )
        :
        [...prev, orderItem]
    )
  }

  const isOrderItemPaid = () => (
    orderForEditDetails?.subPaymentItems?.[orderItem.orderItemId]?.paymentStatus === "paid"
  )

  const total =
    orderItem.systemDiscount < 0 ?
      (orderItem.salePrice - orderItem.systemDiscount)
      * orderItem.quantity
      : orderItem.salePrice * orderItem.quantity

  const isSelected =
    selectedOrderItems.some(oi =>
      oi.orderItemId === orderItem.orderItemId
    )

  const isPaid = isOrderItemPaid()

  const isSelectable =
    isOnline &&
    !isPaid &&
    !orderHasCoupons &&
    !doesOrderHasOneItem

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const renderItems = items => items.map(specificationItem =>
    <div className={classes["row"]} key={`${specificationItem.builderStepKey || "whole"}-${specificationItem._id}`}>
      <div className={classes["extraFood"]}>
        {specificationItem.name}
        {!specificationItem.isSelectable && <Fragment><MdClose /><b>{orderItem.quantity * specificationItem.quantity}</b></Fragment>}
      </div>
      {specificationItem.salePrice > 0 &&
        <div className={classes["specPrice"]}>
          {thousandSeparator(orderItem.quantity * specificationItem.salePrice * (specificationItem.quantity - specificationItem.freeQuantity))}
        </div>
      }
    </div>
  )
  const portionItems = portion => orderItem.specificationItems.filter(item =>
    portion === "whole" ? !item.portion || item.portion === "whole" : item.portion === portion
  )
  const renderPortion = (faTitle, enTitle, portion) => {
    const items = portionItems(portion)
    return items.length > 0 && <section className={classes["portion"]}>
      <div className={classes["portion-title"]}>{i18n.language === "fa" ? faTitle : enTitle}</div>
      {renderItems(items)}
    </section>
  }

  return (
    <div
      onClick={handleSelect}
      className={clsx(
        classes["card"],
        isSelectable && classes["select"],
        isSelected && classes["active"]
      )}
    >
      <div className={classes["row"]}>
        <div className={classes["details"]}>
          <div className={classes["name-container"]} >
            <span className={classes["name"]}>
              {orderItem.foodName}
            </span>
            <span className={classes["quantity"]}>
              <MdClose size={18} />
              <b>{orderItem.quantity}{productUnitsSymbol[orderItem.unit]}</b>
            </span>
          </div>
          {
            !orderItem.isSimple &&
            <div className={classes["optionName"]}>
              ({orderItem.optionName})
            </div>
          }
        </div>
        <div
          className={clsx(
            classes["price"],
            isLtr && classes["price-ltr"]
          )}
        >
          {thousandSeparator(total)}
        </div>
      </div>

      {renderItems(portionItems("whole"))}
      {renderPortion("نیمه اول", "First half", "firstHalf")}
      {renderPortion("نیمه دوم", "Second half", "secondHalf")}

      {
        isPaid &&
        <div className={classes["footer"]}>
          <div className={classes["paid"]}>
            {t("پرداخت_شد")}
          </div>
        </div>
      }
    </div>
  )
}

export default React.memo(CheckoutOrderItem)
